export default {"src":"/_next/static/media/reset-passwd-success.57646b4c.svg","height":300,"width":500,"blurWidth":0,"blurHeight":0};